<template>
  <aside>
    <div class="tutor-details d-flex">
      <img
        :src="tutor.profile_picture_url"
        :alt="tutor.full_name"
        class="profile-pic"
      />
      <div class="details d-flex flex-column">
        <h3 class="name m-0">{{ tutor.full_name }}</h3>
        <div class="more-details-container d-flex align-items-center">
          <div class="rate">
            {{ $t("reservation.rate") }}:
            <span
              >{{ institute_configs.currency_symbol }}
              {{ tutor.rate_per_hour }}</span
            >
          </div>
          <span></span>
          <div class="rating">
            {{ $t("reservation.reviews") }}
            <v-icon small color="#ffc759">mdi-star</v-icon>
            <span>{{ tutor.reviews }}</span>
          </div>
        </div>
        <div class="tutor-items d-flex flex-column">
          <div class="tutor-item">
            <img
              src="../../assets/images/tutors-list/translate.svg"
              alt="translate"
              class="icon"
            />
            <p class="tutor-desc" data-testId="tutor-languages">
              {{ languages }}
            </p>
          </div>
          <div class="tutor-item">
            <img
              src="../../assets/images/tutors-list/school.svg"
              alt="school"
              class="icon"
            />
            <p class="tutor-desc" data-testId="tutor-courses">{{ courses }}</p>
          </div>
          <div class="tutor-item">
            <img
              src="../../assets/images/tutors-list/person.svg"
              alt="person"
              class="icon"
            />
            <p class="tutor-desc">
              {{ tutor.student_count }}
              {{ $t(`Student${tutor.student_count === 1 ? "" : "s"}`) }}
            </p>
          </div>
        </div>
        <!-- <button class="chat-btn" disabled>
          <v-icon small>mdi-message</v-icon> Chat
        </button> -->
      </div>
    </div>
    <div class="about-tutor d-flex flex-column">
      <h3 class="about-title m-0">{{ $t("reservation.aboutMe") }}</h3>
      <p class="about-desc">{{ tutor.bio_data }}</p>
      <video
        v-for="video in videos"
        :id="`video-${video.id}`"
        :key="video.id"
        :src="video.file_url"
        translate
        controls
        preload
        :class="{ hide: hideDetails }"
      ></video>
    </div>
    <a
      class="hide-details d-flex align-items-center justify-content-center"
      @click.prevent="hideDetails = !hideDetails"
      :class="{ 'disable-more-btn': videos && !videos.length }"
    >
      <v-icon color="#5FD068">{{
        !hideDetails ? "mdi-chevron-up" : "mdi-chevron-down"
      }}</v-icon>
      {{
        $t(hideDetails ? "reservation.showDetails" : "reservation.hideDetails")
      }}
    </a>
  </aside>
</template>

<script>
export default {
  name: "TutorDetails",
  props: {
    tutor: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      hideDetails: false,
      institute_configs: JSON.parse(localStorage.getItem("institute_configs")),
    };
  },
  /**
   * Initialize Component
   */
  mounted() {
    window.addEventListener("localstorageChange", (event) => {
      this.institute_configs = JSON.parse(
        event.detail.storage.institute_configs
      );
    });
  },
  computed: {
    /**
     * Get all Courses of tutor
     */
    courses() {
      return this.tutor.courses?.map((c) => c.course_type).join(", ");
    },
    /**
     * Get all languages of tutor
     */
    languages() {
      return this.tutor.languages?.join(", ");
    },
    /**
     * Get all available videos of tutor
     */
    videos() {
      return this.tutor.courses
        ?.flatMap((c) => {
          if (!c.video_documents.length) return;
          return c.video_documents.map((v) => {
            if (!v.file_url) return;
            return v;
          });
        })
        .filter((v) => !!v);
    },
  },
};
</script>

<style lang="scss">
:root {
  font-size: 16px;
}
@media all and (max-width: $max-md-screen) and (min-width: $min-md-screen) {
  :root {
    font-size: 12px;
  }
}
@media all and (max-width: $min-md-screen) {
  :root {
    font-size: 12px;
  }
}
</style>

<style lang="scss" scoped>
aside {
  padding: 1em;
  border: 1px solid $description;
  border-radius: 8px;
  width: 100%;
  height: fit-content;
  font-family: $font-family;
  font-style: normal;
  .tutor-details {
    gap: 11px;
    margin-bottom: 16px;
    .profile-pic {
      width: 154px;
      height: 146px;
      border-radius: 8px;
    }
    .details {
      font-size: 1.25rem;
      font-weight: 500;
      font-size: 1.25rem;
      line-height: 1.75rem;
      color: #061c3d;
      gap: 6px;
      .name {
        font-size: 1.25rem;
      }
      .more-details-container {
        font-weight: 400;
        font-size: 0.6875rem;
        line-height: 100%;
        letter-spacing: 0.01rem;
        text-transform: capitalize;
        color: #838e9e;
        gap: 4px;
        .rate,
        .rating {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 4.5px 0 4.5px 4px;
          span {
            color: $green;
          }
        }
        .rate {
          width: 67px;
        }
        .rating {
          width: 92px;
        }
        & > span {
          height: 14px;
          border-right: 1px solid #e6e8ec;
        }
      }
      .tutor-items {
        gap: 6px;
        .tutor-item {
          display: flex;
          align-items: center;
          gap: 4px;
          .icon {
            width: 1rem;
            height: 1rem;
          }
          .tutor-desc {
            color: $description;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.2;
            margin: 0;
          }
        }
      }
      .chat-btn {
        padding: 6.5px;
        gap: 2px;
        background: $white;
        border: 1px solid $green;
        border-radius: 100px;
        font-weight: 400;
        font-size: 0.685rem;
        line-height: 100%;
        letter-spacing: 0.01rem;
        color: $green;
        &:disabled {
          opacity: 0.5;
          pointer-events: none;
        }
        .v-icon {
          color: $green;
        }
        &:hover {
          border-color: $hover-green;
          color: $hover-green;
          .v-icon {
            color: $hover-green;
          }
        }
      }
    }
  }
  .about-tutor {
    gap: 16px;
    font-weight: 500;
    line-height: 1.25rem;
    margin-bottom: 30px;
    .about-title {
      font-size: 1rem;
      color: #061c3d;
    }
    .about-desc {
      font-size: 1rem;
      color: #42526b;
      margin: 0;
      word-wrap: break-word;
    }
    video {
      border-radius: 8px;
      &.hide {
        display: none;
      }
    }
  }
  .hide-details {
    text-decoration: none;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.375rem;
    color: $green;
    gap: 4px;
    &.disable-more-btn {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
@media all and (min-width: $min-md-screen) and (max-width: $max-md-screen) {
  aside {
    width: 255px;
    padding: 8px;
    .tutor-details {
      gap: 5px;
      margin-bottom: 12px;
      .profile-pic {
        width: 80px;
        height: 75.47px;
      }
      .details {
        .name {
          font-size: 1rem;
        }
        .more-details-container {
          gap: 0;
          font-size: 11px;
        }
        .chat-btn {
          max-width: 147px;
          font-size: 11px;
          i {
            font-size: 11px !important;
          }
        }
      }
    }
    .about-tutor {
      gap: 12px;
      line-height: 1.66rem;
      margin-bottom: 20px;
      .about-title {
        font-size: 1.33rem;
      }
      .about-desc {
        font-size: 1.16rem;
      }
    }
    .hide-details {
      font-size: 1.16rem;
      line-height: 1.83rem;
    }
  }
}
@media all and (max-width: $min-md-screen) {
  aside {
    padding: 16px;
    .tutor-details {
      margin-bottom: 4px;
      .profile-pic {
        width: 123px;
        height: 116px;
      }
      .details {
        .name {
          font-size: 1rem;
        }
        .more-details-container {
          gap: 0;
          font-size: 11px;
        }
        .chat-btn {
          font-size: 11px;
          width: 100%;
          i {
            font-size: 11px !important;
          }
        }
      }
    }
    .about-tutor {
      gap: 12px;
      margin-bottom: 22px;
      .about-title {
        font-size: 1.334rem;
      }
      .about-desc {
        line-height: 20px;
      }
    }
    .hide-details {
      font-size: 1.16rem;
      line-height: 1.83rem;
    }
  }
}
</style>
